import { render, staticRenderFns } from "./SigepTabEquivalents.vue?vue&type=template&id=c1f45504"
import script from "./SigepTabEquivalents.vue?vue&type=script&lang=js"
export * from "./SigepTabEquivalents.vue?vue&type=script&lang=js"
import style0 from "./SigepTabEquivalents.vue?vue&type=style&index=0&id=c1f45504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports